import { Route, Routes } from 'react-router-dom'
import { TableGroups } from './table'
import { AddGroups } from './add'
import { ViewGroups } from './view'

export const BrowserGroups = () => {
  return (
    <Routes>
      <Route path={"/"} element={<TableGroups />} />
      <Route path={"/add"} element={<AddGroups />} />
      <Route path={"/view"} element={<ViewGroups />} />
    </Routes>
  )
}
